import { render, staticRenderFns } from "./CampaignStatistics.vue?vue&type=template&id=1597a6d8&scoped=true&"
import script from "./CampaignStatistics.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStatistics.vue?vue&type=style&index=0&id=1597a6d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597a6d8",
  null
  
)

export default component.exports